let departmentScript = {
    $departmentLinks: $('.department-link'),
    delay: 300,
    menuOffset: 80,
    init: function () {
        let _this = departmentScript
        let $triggerButton = $('.js-toggle-department')
        $triggerButton.on('click', ev => {
            let $target = $(ev.target).closest('.js-toggle-department'),
                $currentDepartmentLink = $target.parent(),
                $currentDepartmentQuestion = $target.next(
                    '.department-questions'
                )
            if ($currentDepartmentLink.hasClass('is-open')) {
                $currentDepartmentLink.removeClass('is-open')
                $currentDepartmentQuestion.slideToggle(
                    _this.delay,
                    function () {
                        $currentDepartmentLink.trigger('update:height')
                    }
                )
                slideToTop($currentDepartmentLink)
            } else {
                $(departmentScript.$departmentLinks).each((index, element) => {
                    if ($(element).hasClass('is-open')) {
                        $(element).removeClass('is-open')
                        $(element)
                            .find('.department-questions')
                            .slideToggle(_this.delay)
                    }
                })
                $currentDepartmentLink.addClass('is-open')
                $currentDepartmentQuestion.slideToggle(
                    _this.delay,
                    function () {
                        $currentDepartmentLink.trigger('update:height')
                    }
                )
                slideToTop($currentDepartmentLink)
            }
        })

        function slideToTop($element) {
            return setTimeout(() => {
                let distanceTop = $element.offset().top - _this.menuOffset
                $('html, body').animate({ scrollTop: distanceTop }, 'slow')
            }, _this.delay)
        }
    },
}

departmentScript.init()
